import { HeaderV3 } from "@circle-react-shared/uikit/HeaderV3";
import { AdminOnlyRouteNotice } from "@circle-react-shared/uikit/HeaderV3/NavigationBar/AdminOnlyRouteNotice";
import { HeaderV4 } from "@circle-react-shared/uikit/HeaderV4";
import { GDPRCookieBanner } from "@circle-react/components/GDPR/GDPRCookieBanner";
import { MasqueradeBanner } from "@circle-react/components/MasqueradeBanner";
import { PostModalOverlay } from "@circle-react/components/PostModal/PostModalOverlay";
import { RailsFlashMessages } from "@circle-react/components/RailsFlashMessages";
import { twoFaPath } from "@circle-react/helpers/urlHelpers";
import { CommunitySwitcherAppData } from "@circle-react/wrappers/CommunitySwitcherAppData";
import { Outlet } from "@tanstack/react-router";
import { OptInBar } from "react/components/NewVersionOptIn/OptInBar";
import { PreviewBar } from "react/components/NewVersionOptIn/PreviewBar";

import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { MainAppContentProps } from "./types";

export const LegacyMainAppContent = ({
  notice,
  alert,
  shouldDisplayHeader,
  shouldDisplayCommunitySwitcher,
  hasMinimalLayout,
}: MainAppContentProps) => {
  const isNotTwoFaPage = globalThis.location.pathname !== twoFaPath();
  const { isCircleV4 } = useCircleV4();

  return (
    <div className="flex w-full">
      {shouldDisplayCommunitySwitcher && (
        <ErrorBoundary>
          <CommunitySwitcherAppData />
        </ErrorBoundary>
      )}
      <div className="w-full">
        <RailsFlashMessages notice={notice} alert={alert} />
        <PreviewBar />
        <OptInBar />
        <MasqueradeBanner />
        {shouldDisplayHeader &&
          !hasMinimalLayout &&
          isNotTwoFaPage &&
          (isCircleV4 ? <HeaderV4 /> : <HeaderV3 />)}
        <Outlet />
        <PostModalOverlay />
        <GDPRCookieBanner />
        <AdminOnlyRouteNotice />
      </div>
    </div>
  );
};
